import { useSelector } from "react-redux";

export const CallCheckLoadsSelectors = () => {
  const state = useSelector(state => state);
  const loadsAssignedStops = useSelector(state => state.callCheckLoads.loadsAssignedStops);
  const loading = useSelector(state => state.callCheckLoads.loading);
  const actionMessage = useSelector(state => state.callCheckLoads.message);
  const hasError = useSelector(state => state.callCheckLoads.hasError);
  const total = useSelector(state => state.callCheckLoads.total);
  const stateFilterOptions = useSelector(state => state.callCheckLoads.filterOptions);
  const statePagination = useSelector(state => state.callCheckLoads.pagination);
  const userFirstName = useSelector(state => state.auth.userFirstName);
  const loadNotes = useSelector(state => state.callCheckLoads.loadNotes);
  const stopNotes = useSelector(state => state.callCheckLoads.stopNotes);
  const orderNotes = useSelector(state => state.callCheckLoads.orderNotes);
  const notesLoading = useSelector(state => state.callCheckLoads.notesLoading);
  const loadDetails = useSelector(state => state.callCheckLoads.loadDetails);
  const loadDetailsLoading = useSelector(state => state.callCheckLoads.loadDetailsLoading);
  const EFSLoading = useSelector(state => state.callCheckLoads.EFSLoading);
  const EFSList = useSelector(state => state.callCheckLoads.EFSList);
  const EFSData = useSelector(state => state.callCheckLoads.EFS);

  return { state, 
    loadsAssignedStops, 
    loading, 
    actionMessage, 
    hasError, 
    total, 
    stateFilterOptions, 
    statePagination, 
    userFirstName, 
    loadNotes, 
    stopNotes,
    orderNotes,
    notesLoading,
    loadDetails,
    loadDetailsLoading,
    EFSLoading,
    EFSList,
    EFSData,
  };
};